function inputs_to_key_value(inputs) {
  const key_values = {};
  Object.entries(inputs).forEach(([key, value]) => {
    if (typeof value.value === 'undefined' || value.value === null || value.value === '') return;

    if (value?.type === 'date') {
      key_values['from'] = value.value[0];
      key_values['to'] = value.value[1];
      return;
    }

    key_values[key] = value.value;
  });

  return key_values;
}

export default inputs_to_key_value;
